import { render, staticRenderFns } from "./searchAlbum.vue?vue&type=template&id=438c1994&scoped=true&"
import script from "./searchAlbum.vue?vue&type=script&lang=ts&"
export * from "./searchAlbum.vue?vue&type=script&lang=ts&"
import style0 from "./searchAlbum.vue?vue&type=style&index=0&id=438c1994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c1994",
  null
  
)

export default component.exports